import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const InfoCard = ({ value, info }) => (
  <div className="info-card">
    <div className={classNames('info-card__value', {
        'info-card__value--disabled': Number(value) === 0,
      })}>
        {value}
    </div>
    <div className="info-card__info">{info}</div>
  </div>
);

InfoCard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  info: PropTypes.node.isRequired,
};

export default InfoCard;
